/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.groupModule')
  .controller('GroupController', ['groupDTO',
    '$state',
    '$stateParams',
    '$window',
    '$rootScope',
    '$scope',
    'Restangular',
    '$translate',
    'AeroDialogService',
    'BulbAuthService',
    'BulbBlockViewSwitcherService',
    'BulbBrowserService',
    'BulbBusyService',
    'BulbErrorService',
    'BulbGroupService',
    'BulbGoogleClassroomImportService',
    'BulbInappropriateContentService',
    'BulbModalService',
    'BulbShareService',
    'BulbUtilitiesService',
    'GroupHttpService',
    'AUTH',
    '_',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    GroupController]);

function GroupController(
  groupDTO,
  $state,
  $stateParams,
  $window,
  $rootScope,
  $scope,
  Restangular,
  $translate,
  AeroDialogService,
  BulbAuthService,
  BulbBlockViewSwitcherService,
  BulbBrowserService,
  BulbBusyService,
  BulbErrorService,
  BulbGroupService,
  BulbGoogleClassroomImportService,
  BulbInappropriateContentService,
  BulbModalService,
  BulbShareService,
  BulbUtilitiesService,
  GroupHttpService,
  AUTH,
  _,
) {
  const that = this;
  this.group = groupDTO;
  this.filteredUnits = [...this.group.children];
  this.dateGroupWasClosed = that.group.lastDateClosed
    ? BulbUtilitiesService.convertDateWithTranslatedMonth(that.group.lastDateClosed) : null;
  this.emailOrUsername = '';
  this.remainingGroups = BulbGroupService.getRemainingGroups();

  this.isOwner = BulbAuthService.currentUser.hasPermission(this.group, AUTH.PERMISSIONS.DELETE);
  $scope.viewSwitcherService = BulbBlockViewSwitcherService;
  this.searchDraft = '';
  this.searchText = '';
  this.useGroupName = BulbAuthService.currentUser.useGroupName;

  // eslint-disable-next-line no-param-reassign
  BulbBlockViewSwitcherService.unitTypeToOpenInNewTab = this.group.unitType;

  this.activeTab = 'content';
  // GroupHttpService.activeTab ||
  /**
   * List of all sort options.
   */
  this.list = [
    { value: 'name', display: $translate.instant('group_filter_title') },
    { value: 'lastUpdate', display: $translate.instant('group_filter_date') },
    { value: 'ownerDisplayName', display: $translate.instant('group_filter_author') },
  ];

  /**
   * Default sort options.
   */
  this.sortOptions = this.list;

  /**
   * Default sort by property.
   */
  this.sortBy = 'name';

  /**
   * Default sort order.
   */
  this.sortAscending = true;

  /**
   * Placeholder for search box.
   */
  this.searchPlaceholder = $translate.instant('search_content');

  // Find the group owner and member status.
  this.isMember = false;

  this.groupInviteToken = '';

  this.draggedUnit = null;

  this.isAssignmentCompositeUnit = this.group.assignments.length > 0;

  let groupOwner;
  let currentMember;
  this.members = this.group.members;
  if (this.members.length > 0) {
    groupOwner = this.members.find((owner) => owner.owner);
    currentMember = this.members.find((current) => current.accountId === BulbAuthService.currentUser.id);
    if (currentMember) {
      this.isMember = true;
    }
  }
  // Display assignment composite unit first in child list.
  if (this.group.children.length > 0) {
    const children = _.partition(this.group.children, (child) => child.unitType === 'AssignmentCompositeUnit');
    this.group.children = children[0].concat(children[1]);
  }

  // Do a REST call to get the invite token when the group is being loaded. If there is no token already, then
  // generate one.
  Restangular.one(`token/group/${this.group.id}`).get().then((inviteToken) => {
    that.groupInviteToken = inviteToken.token;
  }, () => {
    // If there is no code found, then generate one if current member is owner of the group.
    if (currentMember?.owner) {
      Restangular.all(`token/group/${that.group.id}`).post().then((inviteToken) => {
        that.groupInviteToken = inviteToken.token;
      });
    }
  });

  this.setActiveTab = (tab) => {
    this.activeTab = tab;
    GroupHttpService.setActiveTab(tab);
    that.searchPlaceholder = $translate.instant(`search_${tab}`);
    that.filteredUnits = that.activeTab === 'assignments' ? that.group.assignments : that.group.children;
    if (tab === 'assignments') {
      that.sortOptions = that.list.slice(0, 2);
      that.sortBy = 'name';
    } else {
      that.sortOptions = that.list;
      that.sortBy = 'name';
    }
    that.searchDraft = '';
    this.searchText = '';
  };

  this.setActiveTab(this.activeTab);

  // Check to find out if it is a mobile device so that we hide Resync with Google Classroom button. We do want to
  // have re-sync option enabled for devices such as iPad.
  this.isMobile = BulbBrowserService.isIOSMobile() || BulbBrowserService.isAndroid()
    || BulbBrowserService.isWindowsMobile();

  /**
   * Create a listener to update member on re-sync Google Classroom group members.
   */
  $rootScope.$on('members', (event, members) => {
    that.members = members;
  });

  if ($stateParams.welcome) {
    this.showGroupWelcomeDialog = ($stateParams.welcome && this.isMember === false);
  }

  // Populates the welcome dialog title and body var for anonymous or pending member.
  if (this.showGroupWelcomeDialog) {
    let welcomeBody = 'group_welcome_body';
    let buttonCode = 'group_welcome_visit';
    const authenticated = BulbAuthService.currentUser.isAuthenticated();
    if (!authenticated) {
      welcomeBody = 'group_welcome_anonymous_body';
      buttonCode = 'sign_in';
    }

    const modalOptions = {
      titleCode: 'group_welcome_title',
      okButtonCode: buttonCode,
      showCancelButton: false,
      templateUrl: 'groupwelcome.nested',
      controller: ['$scope', ($scope) => {
        $scope.group = that.group.name;
        $scope.welcomeBody = welcomeBody;
        $scope.authenticated = authenticated;
        $scope.signUp = () => {
          $scope.$dismiss();
          $state.go('signUp', { targetUrl: $window.location.href });
        };
      }],
    };

    BulbModalService.show(modalOptions).then(() => {
      if (!authenticated) {
        $state.go('signIn', { targetUrl: $window.location.href });
      }
    }, () => {
      // Doing nothing on a cancel, besides the implicit closing of the dialog.
    });
  }

  /**
   * Adds/invites a member to the groupId by an email username.
   */
  this.addMember = function addMember() {
    BulbBusyService.showBusyDuring(
      Restangular.one('groups', that.group.id).all('members').customPOST({ emailOrUsername: that.emailOrUsername })
        .then((data) => {
          that.members.push(data);
          that.emailOrUsername = '';
        }, (error) => {
          // This error is thrown when a user is added to a group they are already a member of.
          // We don't want to display an error modal to the user when this is the error.
          if (error.data?.developerMessage.includes('HibernateConstraintViolation')) return;
          if (error.data.errorMap) {
            // allow the form controller to handle field validation errors:
            that.addMemberForm.handleRemoteErrors(error);
          } else {
            BulbErrorService.showError(null, error);
          }
        }),
    );
  };

  /**
   * Sets the sorting property based on the selected option from the event
   * and re-applies the sorting logic.
   *
   * @param {Object} event - The event containing the selected option.
   */
  this.setSortBy = function setSortBy(event) {
    that.sortBy = event.selectedOption;
    that.sortByProperty();
  };

  /**
   * Toggles the sort order between ascending and descending,
   * then re-applies the sorting logic.
   */
  this.toggleSort = function toggleSort() {
    that.sortAscending = !that.sortAscending;
    that.sortByProperty();
  };

  /**
   * Handles the drag start event for a unit tile.
   * Prepares the drag payload, custom drag image, and sets up cleanup logic.
   *
   * @param {DragEvent} event - The drag event triggered when the user starts dragging.
   * @param {HTMLElement} element - The DOM element being dragged.
   * @param {Object} childUnit - The unit data associated with the dragged element.
   */
  this.handleDragStart = function (event, element, childUnit) {
    const payload = {
      unit: childUnit,
    };
    const dragImage = element.cloneNode(true);
    const bottomSection = dragImage.querySelector('.bulb-tile-footer-container');
    if (bottomSection) {
      bottomSection.style.display = 'none';
    }

    document.body.appendChild(dragImage);
    event.dataTransfer.setDragImage(dragImage, 0, 0);
    event.dataTransfer.setData('application/json', JSON.stringify(payload));
    event.dataTransfer.effectAllowed = 'move';

    event.target.addEventListener('dragend', () => {
      const dropZoneElements = document.querySelectorAll('#pinnedUnitArea, .upgraded-blocks');
      dropZoneElements.forEach((element) => { element.classList.remove('drop-highlight'); });
      document.getElementById('pinnedUnitArea').style.border = 'none';
      document.getElementById('pinnedUnitArea').style.borderBottom = '2px solid #28292D';
      if (document.body.contains(dragImage)) {
        document.body.removeChild(dragImage);
      }
    });
  };

  /**
   * Refreshes the current view by reloading the current state.
   */
  this.refreshView = function refreshView() {
    $state.reload();
  };

  /**
   * Register global refreshView listener.
   */
  this.$onInit = function onInit() {
    window.addEventListener('refreshView', that.refreshView);
  };

  /**
   * Cleanup listener on controller destroy.
   */
  $scope.$on('$destroy', () => {
    window.removeEventListener('refreshView', that.refreshView);
  });

  /**
   * Opens the multiple user invite dialog if they are pasting in a list or adding multiple users with a space.
   */
  this.openInviteDialog = function openInviteDialog() {
    // Open the invite multiple members dialog if there is multiple lines or a space.
    if (/\r|\n/.test(this.addMemberForm.emailOrUsername.$viewValue)
      || /.\s./.test(this.addMemberForm.emailOrUsername.$viewValue)) {
      const input = this.addMemberForm.emailOrUsername.$viewValue;

      let invitedUsers;
      if (input.endsWith(' ', input.length - 1)) {
        invitedUsers = [input.substring(0, input.length - 2), ''];
      } else {
        invitedUsers = input.split(/\r|\n/);
      }
      AeroDialogService.showGroupInviteDialog(this.group.id, invitedUsers, that.members, true);
      this.emailOrUsername = '';
    }
  };

  /**
   * Removes a member from this group by email or accountId.
   */
  this.removeMember = function removeMember(member) {
    if (this.isOwner && groupOwner.accountId !== member.accountId) {
      // If the username (there is an Account) is null, use the displayName containing the email address to
      // delete.
      let emailOrUsername = member.username;
      let isEmail = false;
      if (emailOrUsername === null) {
        emailOrUsername = member.displayName;
        isEmail = true;
      }

      BulbBusyService.showBusyDuring(
        Restangular.one('groups', that.group.id).one('members')
          .customOperation(
            'remove',
            '',
            null,
            { 'content-type': 'application/json' },
            { emailOrUsername },
          )
          .then((group) => {
            that.group = group;
            that.members = group.members;
          }, (error) => {
          // FUTURE: group member is removed, but find out why Restangular/Jackson does not like email
          // deletions.
            if (error.status === 406 && isEmail) {
            // Just remove member from the list.
              const index = that.members.indexOf(member);
              if (index > -1) {
                that.members.splice(index, 1);
              }
            } else {
              BulbErrorService.error('Cannot delete a group member', error);
            }
          }),
      );
    }
  };

  /**
   * Changes the active status for the group.
   */
  this.toggleGroupActive = function toggleGroupActive(callback = () => {}) {
    const isGroupOpen = this.group.active;
    if (this.isOwner) {
      if (isGroupOpen) {
        // This means we're toggling the group closed, if it is open right now, so show the modal.
        BulbGroupService.closeGroupModalOptions.onPrimary = () => {
          BulbGroupService.toggleGroupStatus(that.group).then((groupObject) => {
            that.group = groupObject.updatedGroup;
            that.remainingGroups = groupObject.remainingGroups;
            callback();
          });
        };
        AeroDialogService.showDialog(BulbGroupService.closeGroupModalOptions);
      } else {
        // If we're turning the group on, don't show the modal, since we don't need to show it.
        const promise = BulbGroupService.toggleGroupStatus(that.group);

        promise.then((groupObject) => {
          that.group = groupObject.updatedGroup;
          that.remainingGroups = groupObject.remainingGroups;
          callback();
        });
      }
    }
  };

  this.getMemberUiSref = function getMemberUiSref(member) {
    // FUTURE: If there's no member.username we return '.', meaning the current state.  As of angular-ui-router
    // version 0.2.15 there's no way to set ui-sref to a null or empty value to disable the state transition.
    return member.username ? `author({username: "${member.username}"})` : '.';
  };

  this.getPrimaryMemberStatus = function getPrimaryMemberStatus(membership) {
    if (membership.owner) {
      return 'OWNER';
    }
    return 'MEMBER';
  };

  /**
   * @returns {*|boolean} Whether the submit button should be disabled.
   *
   * This function exists simply because the test was getting complicated so it was moved here rather than being
   * expanded in the template.
   */
  this.isAddMemberButtonDisabled = function isAddMemberButtonDisabled() {
    // Testing here whether there is a value or not instead of using a 'required' validation because the required
    // validation shows up too frequently and it makes for an unclean user experience.
    return (this.addMemberForm.$invalid
      || this.addMemberForm.$pristine
      || !this.emailOrUsername
      || this.emailOrUsername === '');
  };

  /**
   * Re-Sync class with Google classroom .
   */
  const reSyncGoogleClass = function reSyncGoogleClass(id) {
    BulbGoogleClassroomImportService.reSyncGroupWithClassroom(id).then(() => {
      BulbBusyService.showBusyDuring(
        BulbGroupService.reSyncClassroomGroup(that.group.id, id, BulbGoogleClassroomImportService.oauthToken)
          .then((group) => {
            $rootScope.$emit('members', group.members);
            that.group.name = group.name;
          }, (bulbError) => {
            BulbErrorService.showError($translate.instant('import_class_from_classroom_error_resync'), bulbError);
          }),
      );
    }, (error) => {
      if (error) {
        BulbErrorService.showError($translate.instant('import_class_from_classroom_error_resync'), error);
      }
    });
  };

  /**
   * Filters the units (assignments or children) based on the given search text.
   * - If no search text is provided, resets to all units.
   * - Filters against `unit.name` and `unit.ownerDisplayName` in a case-insensitive manner.
   * - Updates `that.filteredUnits` with the result.
   *
   * @param {string} searchText - The text input used to filter units.
   *
   */
  this.searchFilter = function searchFilter(searchText) {
    const sourceUnits = that.activeTab === 'assignments'
      ? that.group.assignments
      : that.group.children;
    if (!searchText) {
      that.filteredUnits = [...sourceUnits];
      that.searchText = that.searchDraft;
      return;
    }
    const text = String(searchText).trim().toLowerCase();

    that.filteredUnits = [...sourceUnits.filter((unit) => (unit.name && unit.name.toLowerCase().includes(text))
      || (unit.ownerDisplayName && unit.ownerDisplayName.toLowerCase().includes(text)))];
    that.searchText = that.searchDraft;
  };

  /**
   * Sorts the currently filtered units by the active property (`sortBy`).
   * - Strings are compared in a case-insensitive manner.
   * - Null or undefined values are pushed to the end.
   * - Sort order depends on `sortAscending` (true = ascending).
   */
  this.sortByProperty = function sortByProperty() {
    that.filteredUnits.sort((a, b) => {
      let aVal = a[that.sortBy];
      let bVal = b[that.sortBy];

      // Handle missing or null values — they go to the end
      const aMissing = aVal === undefined || aVal === null;
      const bMissing = bVal === undefined || bVal === null;

      if (aMissing && bMissing) return 0;
      if (aMissing) return 1;
      if (bMissing) return -1;

      // Convert strings to lowercase for case-insensitive comparison
      if (typeof aVal === 'string') aVal = aVal.toLowerCase();
      if (typeof bVal === 'string') bVal = bVal.toLowerCase();

      // Compare values based on sortAscending boolean
      if (aVal < bVal) return that.sortAscending ? -1 : 1;
      if (aVal > bVal) return that.sortAscending ? 1 : -1;
      return 0;
    });
  };

  that.sortByProperty();

  // To unset the value of unitTypeToOpenInNewTab when user leaves the group page.
  $scope.$on('$destroy', () => {
    // eslint-disable-next-line no-param-reassign
    BulbBlockViewSwitcherService.unitTypeToOpenInNewTab = '';
  });

  /**
   * Angular Menu Data
   * These properties are passed to an Angular component to build the menu.
   */

  const groupOptionsMenu = [
    {
      label: $translate.instant('social_dialog_title'),
      icon: 'paper-plane',
      command: ($event) => BulbShareService.displayShareDialog($event),
    },
    {
      label: $translate.instant('import_class_from_classroom_resync'),
      icon: 'sync',
      command: () => reSyncGoogleClass(that.group.googleCourseId),
      hidden: !(that.isOwner && that.group.active && that.group.groupType === 'google'),
    },
    {
      label: $translate.instant('inappropriate_content_modal_title', {
        type: 'group',
      }),
      icon: 'flag',
      command: ($event) => BulbInappropriateContentService.openModal($event, that.group),
      // app/menus/menus.d.ts: ColorOptions.ALERT
      color: 'var(--bulb-darker-red-color)',
    },
    {
      label: $translate.instant(that.group.active ? 'group_menu_close' : 'group_menu_open'),
      icon: that.group.active ? 'do-not-enter' : 'door-open',
      hidden: !that.isOwner || (!that.group.active && that.remainingGroups === 0),
      command: () => that.toggleGroupActive(() => {
        that.optionsMenuItems[3].label = $translate.instant(that.group.active ? 'group_menu_close' : 'group_menu_open');
        that.optionsMenuItems[3].icon = that.group.active ? 'do-not-enter' : 'door-open';
        that.optionsMenuItems[3].hidden = !that.isOwner || (!that.group.active && that.remainingGroups === 0);
      }),
    },
  ];

  that.optionsMenuItems = groupOptionsMenu;
}
